import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getAvailableUsStates} from 'src/openapi/admin/apis/GetAvailableUsStatesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectUsStates} from './services/dictionary-slice';

export const useUsStates = () => {
    const apiDispatch = useAppDispatch();
    const usStates = useSelector(selectUsStates);

    const loadUsStates = useCallback(() => {
        if (!usStates.length) {
            apiDispatch(getAvailableUsStates());
        }
    }, [usStates.length, apiDispatch]);

    const getStateByCode = useCallback((code: string) => {
        return usStates?.find(e => e.code === code);
    }, [usStates]);

    return {usStates, loadUsStates, getStateByCode};
};
